import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
declare global {
  interface Window { dataLayer: any }
}
@Injectable({
  providedIn: 'root'
})
export class DataLayerService {
  gtmInit() {
    const script = document.createElement('script');
    script.innerHTML = `window.dataLayer = window.dataLayer || [];
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${environment.gtmId}');`;
    document.head.appendChild(script);
  }

  clarityInit() {
    const script = document.createElement('script');
    script.innerHTML = `(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script",'${environment.clarityId}');`;
    document.head.appendChild(script);
  }

  formbricksInit() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const win = window as any;
    if (!environment.formbricksEnabled || win.formbricksInitialized) {
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `${environment.formbricksAppUrl}/js/formbricks.umd.cjs`;
    script.onload = () => {
      if (!win.formbricksInitialized && win.formbricks) {
        win.formbricksInitialized = true;
        win.formbricks.setup({
          workspaceId: environment.formbricksWorkspaceId,
          appUrl: environment.formbricksAppUrl
        });
      }
    };
    document.head.appendChild(script);
  }

  logEvent(event: string, props: object) {
    window.dataLayer = window.dataLayer || [];
    if (event) {
      window.dataLayer.push({
        event,
        ...props,
      });
    } else {
      window.dataLayer.push({
        ...props,
      });
    }
  }
}
